import { connect } from 'react-redux';

import { VIEWS } from 'legacy/routes/constants';

import { getIsMobile } from 'selectors/match-media';
import { getIsViewingSharedReport } from 'selectors/property-explorer';

import UserDefinedLocationMarkerPopup from 'legacy/components/UserDefinedLocationMarkerPopup';

const mapStateToProps = (state) => {
  return {
    hideButton: getIsMobile(state),
    buttonView: getIsViewingSharedReport(state)
      ? VIEWS.LOCATION_MAP_SHARED
      : VIEWS.LOCATION_MAP
  };
};

const mapDispatchToProps = () => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserDefinedLocationMarkerPopup);
